import * as React from 'react';
import { Form } from 'react-bootstrap';

type OwnProps = {
    value: Date;
    errorMsg: string;
};

export type DispatchProps = {
    onChange: (e: any) => void;
};

type Props = DispatchProps & OwnProps;

export default class EupatiDateMenu extends React.Component<Props> {

    render() {
        return (
            <>
                <Form.Group>
                    <Form.Control
                        type='date'
                        className="eupati-datemenu"
                        value={this.props.value.toString()}
                        onChange={(e) => this.props.onChange(e)}
                    />
                    {!!this.props.errorMsg &&
                        <span className='text-danger'>{this.props.errorMsg}</span>
                    }
                </Form.Group>
            </>
        );
    }
}
